/**
 * Set Navigation Dropdown Class
 * @param  {String} nav [navigation class]
 */
const handleNavDropdownClass = (nav = '.nav') => {
	const $nav = $(nav);
	const hasNav = $nav.length > 0;

	if (! hasNav) {
		return;
	}

	$nav.find('> ul > li').each(function() {
		const $this = $(this);
		const hasDropdown = $this.find('> ul').length > 0;

		if (! hasDropdown) {
			return;
		}

		$this.addClass('has-dropdown');
	});
}

handleNavDropdownClass();
